import { defineRoute } from "src/routing/defineRoute";

/**
 * Path + typed URL builder pairs for `/libraries/templates/schedule-templates/*`.
 *
 * Kept separate from the route tree so `RouteUrls.ts` and pages can import paths without a cycle
 * through page `Component` imports.
 */
export const scheduleTemplatesRoute = defineRoute("/libraries/templates/schedule-templates");
export const scheduleTemplateRoute = defineRoute("/libraries/templates/schedule-templates/:scheduleTemplateId");
